module.exports = __webpack_public_path__ + "static/media/star.9e8af3de.svg";